import { render, staticRenderFns } from "./DetailsCFS.vue?vue&type=template&id=0c4db4d2&scoped=true&"
import script from "./DetailsCFS.vue?vue&type=script&lang=js&"
export * from "./DetailsCFS.vue?vue&type=script&lang=js&"
import style0 from "./DetailsCFS.vue?vue&type=style&index=0&id=0c4db4d2&prod&lang=scss&"
import style1 from "./DetailsCFS.vue?vue&type=style&index=1&id=0c4db4d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4db4d2",
  null
  
)

export default component.exports